<template>
  <form  @submit.prevent="submitForm(password)" autocomplete="off">
    <div class="form-common tc" v-cloak>
      <h3 class="title">Reset your password</h3>
      <div class="input-group-wrap">
        <div class="input-group" :class="{error: validation.hasError('password') || validatePsw }">
          <input id="name" type="password" placeholder="New password" class="name" name="password"
                 :type="showPwd?'text':'password'"
                 v-model.trim="password">
          <i class="iconfont"
             :class="showPwd?'icon-eye-fill':'icon-eye-off-fill'"
             @click="handleShowPwd"></i>
        </div>
        <p class="error-msg tl">{{ validation.firstError('password') || errPsw}}</p>
      </div>
      <div class="input-group-wrap">
        <div class="input-group" :class="{error: validation.hasError('repeat') }">
          <input class="psw w-100" placeholder="Confirm Password"
                 :type="showRepeat?'text':'password'"
                 v-model.trim="repeat">
          <i class="iconfont icon-eye-off-fill"
             :class="showRepeat?'icon-eye-fill':'icon-eye-off-fill'"
             @click="handleShowRepeat"></i>
        </div>
        <p class="error-msg tl">{{ validation.firstError('repeat')}}</p>
      </div>
      <button class="btn submit-btn {loading: is_loading}" type="submit" :style="disableBtn">SAVE</button>
    </div>
  </form>

</template>

<script>
  import {validateError} from '../../common/utils/errors';
  import adminService from '../service/adminService';
  import loading from "../../common/utils/loading";
  import Vue from 'vue';
  import SimpleVueValidation from 'simple-vue-validator';
  const Validator = SimpleVueValidation.Validator;
  import LS from "local-storage";

  Vue.use(SimpleVueValidation);

  export default {
    name: "reset-password",

    data(){
      return{
        password:'',
        repeat:'',
        submitted: false,
        showPwd: false,
        showRepeat: false,
        errPsw:'',
        validatePsw: false,
        is_loading: false,
      }
    },
    computed: {
      disableBtn() {
        if(this.password && this.repeat){
          return {
            opacity: 1
          };
        }else {
          return {
            opacity: .3
          }
        }
      }
    },
    mounted(){
      this.getHash();
    },
    methods: {
      getHash(){
        loading.show();
        let params = new URLSearchParams(location.search.substring(1));
        const hash = params.get("hash");
        if(hash){
          LS.set('hash', hash);
          loading.hide();
          return;
        }

        this.$router.replace({
          path: '/sign-in',
        });
        loading.hide();
      },
      submitForm:function(pwd){
        const hash = LS.get('hash');
        this.submitted = true;

        this.$validate()
            .then(success => {
              console.log(hash, this.repeat);
             if(success){
               this.errPsw = '';
               if (this.is_loading) return;
               this.is_loading = true;
               loading.show();
               adminService.resetPwd(hash, pwd)
                   .then((res) => {
                     if (res) {
                       console.log(res);
                       this.$router.replace({
                         path: "/sign-in"
                       });
                     }
                   })
                   .catch((err)=>{
                     if(err instanceof validateError){
                       const validate = err.getError();
                       if(validate.pwd){
                         this.errPsw = validate.pwd;
                         this.validatePsw = true;
                       }
                     }
                   })
                   .finally(() => {
                     this.is_loading = false;
                     loading.hide();
                   })
             }


            });
      },
      handleShowPwd(){
        if(this.showPwd){
          return this.showPwd = false
        }
        return this.showPwd = true;
      },
      handleShowRepeat(){
        if(this.showRepeat){
          return this.showRepeat = false
        }
        return this.showRepeat = true;
      }
    },
    validators: {

      password: function(value) {
        return Validator.value(value).required();
      },
      'repeat,password': function(repeat,password) {
        if(this.submitted || this.validation.isTouched('repeat')){
          return Validator.value(repeat).required().match(password);
        }
      }


    },

  }
</script>
